function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import * as React from 'react';
import cs from 'classnames';
import ApplyCheck from '../../Icons/ApplyCheck/ApplyCheck';
import EditPencil from '../../Icons/EditPencil/EditPencil';
import TrashCan from '../../Icons/TrashCan/TrashCan';
import tint from '../../utils/colors/tint';
import closest from '../../utils/dom/closest';
import ClientColorCss from '../../ClientColorCss/ClientColorCss';
import DragHandle from '../DragHandle/DragHandle';
import DraggableActions from '../DraggableActions/DraggableActions';
import IconButton from '../../Buttons/IconButton/IconButton';
import ThemeContext from '../../ThemeContext';
import Tooltip from '../../Tips/Tooltip/Tooltip';
import './BlueBox.css';
var BlueBox = /*#__PURE__*/function (_React$Component) {
  _inherits(BlueBox, _React$Component);
  function BlueBox() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, BlueBox);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(BlueBox)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.setRef = function (ref) {
      _this.ref = ref;
      if (_this.props.provided.innerRef) {
        _this.props.provided.innerRef(ref);
      }
    };
    // using the callback ref pattern here so both this component and its parent
    // can use the ref (similar to react-beautiful-dnd's approach)
    _this.setBoxRef = function (ref) {
      _this.boxRef = ref;
      if (_this.props.boxRef) {
        _this.props.boxRef(ref);
      }
    };
    _this.handleClick = function (e) {
      if (!_this.props.edit) {
        _this.props.onClick(_this.props.id);
      }
    };
    _this.handleDoubleClick = function (e) {
      return _this.props.onDoubleClick(_this.props.id);
    };
    _this.handleMouseEnter = function (e) {
      return _this.props.onMouseEnter(_this.props.id);
    };
    _this.handleMouseLeave = function (e) {
      return _this.props.onMouseLeave(_this.props.id);
    };
    _this.handleFocus = function (e) {
      if (!_this.props.edit) {
        _this.props.onFocus(_this.props.id);
      }
    };
    _this.handleBlur = function (e) {
      e.stopPropagation();
      clearTimeout(_this.blurTimeout);
      var target = e.relatedTarget;
      var edit = _this.props.edit;
      var ref = _this.ref;
      // Firefox doesn't support e.relatedTarget on blur, so this is a super hack
      _this.blurTimeout = setTimeout(function () {
        target = target || document.activeElement;
        if (ref && !ref.contains(target) && edit && !closest(target, '.fr-popup')) {
          _this.props.onApply(_this.props.id);
        }
      }, 0);
    };
    _this.handleFocusOut = function (e) {
      if (!_this.ref.contains(e.relatedTarget) && !_this.props.edit) {
        _this.props.onBlur(_this.props.id);
      }
    };
    _this.setEditing = function (e) {
      e.stopPropagation();
      _this.props.setEditing(_this.props.id);
    };
    _this.handleApply = function (e) {
      e.stopPropagation();
      _this.props.onApply(_this.props.id);
    };
    _this.renderEditButton = function () {
      return /*#__PURE__*/React.createElement(Tooltip, {
        i18nKey: "@dm/components.form-builder.labels.edit"
      }, function (_ref) {
        var ref = _ref.ref,
          labelledby = _ref.labelledby,
          events = _ref.events;
        return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
          value: "dm"
        }, /*#__PURE__*/React.createElement(IconButton, Object.assign({
          ref: ref,
          className: "_dm-button--bluebox auto-edit-field",
          onClick: _this.setEditing,
          "aria-labelledby": labelledby
        }, events), /*#__PURE__*/React.createElement(EditPencil, {
          className: "_dm-icon--bluebox"
        })));
      });
    };
    _this.renderApplyButton = function () {
      return /*#__PURE__*/React.createElement(Tooltip, {
        i18nKey: "@dm/components.form-builder.labels.apply"
      }, function (_ref2) {
        var ref = _ref2.ref,
          labelledby = _ref2.labelledby,
          events = _ref2.events;
        return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
          value: "dm"
        }, /*#__PURE__*/React.createElement(IconButton, Object.assign({
          ref: ref,
          className: "_dm-button--bluebox auto-apply-field",
          onClick: _this.handleApply,
          "aria-labelledby": labelledby
        }, events), /*#__PURE__*/React.createElement(ApplyCheck, {
          className: "_dm-icon--bluebox"
        })));
      });
    };
    return _this;
  }
  _createClass(BlueBox, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.edit && this.props.edit) {
        this.boxRef && this.boxRef.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$provided = _this$props.provided,
        provided = _this$props$provided === void 0 ? {} : _this$props$provided,
        _this$props$snapshot = _this$props.snapshot,
        snapshot = _this$props$snapshot === void 0 ? {} : _this$props$snapshot,
        hover = _this$props.hover,
        active = _this$props.active,
        edit = _this$props.edit,
        _this$props$isEditabl = _this$props.isEditable,
        isEditable = _this$props$isEditabl === void 0 ? true : _this$props$isEditabl,
        actions = _this$props.actions,
        draggable = _this$props.draggable,
        addables = _this$props.addables,
        dragging = _this$props.dragging,
        onDelete = _this$props.onDelete,
        isDeletable = _this$props.isDeletable,
        children = _this$props.children,
        _this$props$theme = _this$props.theme,
        theme = _this$props$theme === void 0 ? 'dm' : _this$props$theme;
      var showHoverStyles = hover && !(active || edit || snapshot.isDragging);
      var showDragHandle = dragging ? snapshot.isDragging : draggable;
      var showLiveStyles = snapshot.isDragging || hover || active || edit;
      return /*#__PURE__*/React.createElement(React.Fragment, null, theme === 'dm' && /*#__PURE__*/React.createElement(ClientColorCss, {
        id: "bluebox-client-colors"
      }, function (_ref3) {
        var linkColorPrimary = _ref3.linkColorPrimary,
          linkColorSecondary = _ref3.linkColorSecondary;
        var hoverStyle = tint(linkColorSecondary, 75);
        return "\n\t\t\t\t\t\t\t\t._bluebox--live--dm {\n\t\t\t\t\t\t\t\t\tborder-color: ".concat(linkColorPrimary, "\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t._bluebox--hover--dm,\n\t\t\t\t\t\t\t\t.addables-box--dm {\n\t\t\t\t\t\t\t\t\tbackground-color: ").concat(hoverStyle, "\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t._bluebox--active--dm,\n\t\t\t\t\t\t\t\t._bluebox--edit--dm,\n\t\t\t\t\t\t\t\t._bluebox--dragging--dm {\n\t\t\t\t\t\t\t\t\tbackground-color: ").concat(linkColorSecondary, "\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t");
      }), /*#__PURE__*/React.createElement("div", Object.assign({
        ref: this.setRef
      }, provided.draggableProps), /*#__PURE__*/React.createElement("div", {
        ref: this.setBoxRef,
        className: cs("_bluebox", '_dm-break-text', 'auto-bluebox', _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "_bluebox--live--".concat(theme), showLiveStyles), '_bluebox--at-rest', !showLiveStyles), "_bluebox--hover--".concat(theme), showHoverStyles), "_bluebox--active--".concat(theme), active), "_bluebox--edit--".concat(theme), edit), '_bluebox--with-handle', draggable), '_bluebox--with-actions', actions), "_bluebox--dragging--".concat(theme), snapshot.isDragging)),
        tabIndex: 0,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onClick: this.handleClick,
        onDoubleClick: this.handleDoubleClick,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
        // not a React synthetic event (it'll complain in dev mode), but
        // necessary so Firefox has e.relatedTarget (doesn't support it for blur)
        ,
        onFocusOut: this.handleFocusOut
      }, showDragHandle ? /*#__PURE__*/React.createElement(DragHandle, {
        dragHandleProps: provided.dragHandleProps
      }) :
      /*#__PURE__*/
      // react-beautiful-dnd will flip 💩 if there isn't a dummy element
      // here with dragHandleProps on it
      React.createElement("span", provided.dragHandleProps), children, (active || edit) && /*#__PURE__*/React.createElement(DraggableActions, null, active && isEditable && this.renderEditButton(), edit && this.renderApplyButton(), isDeletable && /*#__PURE__*/React.createElement(Tooltip, {
        i18nKey: "@dm/components.form-builder.labels.delete"
      }, function (_ref4) {
        var ref = _ref4.ref,
          labelledby = _ref4.labelledby,
          events = _ref4.events;
        return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
          value: "dm"
        }, /*#__PURE__*/React.createElement(IconButton, Object.assign({
          ref: ref,
          onClick: onDelete,
          className: "_dm-button--bluebox _dm-button--bluebox__trash auto-delete-field",
          "aria-labelledby": labelledby
        }, events), /*#__PURE__*/React.createElement(TrashCan, {
          className: "_dm-icon--bluebox"
        })));
      }))), active && !snapshot.isDragging && addables && /*#__PURE__*/React.createElement("div", {
        className: "addables-box--".concat(theme)
      }, addables)));
    }
  }]);
  return BlueBox;
}(React.Component);
export { BlueBox as default };